import { Map, Record } from 'immutable'

export const EntityRecord = Record({
    id: 0,
    name: '',
    country: Map({
        iso2: '',
        iso3: '',
        name: '',
    }),
    indicators: Map({
        caution: 0,
        notice: 0,
        risk: 0,
    }),
    type: '',
    corporation: Map({
        regNbr: '',
        activity: Map({
            active: false,
            endDate: Map({
                precision: '',
                value: '',
            }),
            startDate: Map({
                precision: '',
                value: '',
            }),
        }),
    }),
    soleProprietor: Map({
        regNbr: '',
        dateOfBirth: Map({
            precision: '',
            value: '',
        }),
        gender: '',
        activity: Map({
            active: false,
            endDate: Map({
                precision: '',
                value: '',
            }),
            startDate: Map({
                precision: '',
                value: '',
            }),
        }),
    }),
    naturalPerson: Map({
        dateOfBirth: Map({
            precision: '',
            value: '',
        }),
        gender: '',
    }),
})
